import { trainingProgrammes } from "@/mocks/training";

export default function Training() {
  return (
    <section
      id="training"
      className="w-full bg-background-100 py-10 md:py-12 lg:py-14"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Capacity Development
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            Developing People. Strengthening Industry.
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-700 max-w-3xl mx-auto leading-relaxed">
            A&amp;J&apos;s training ecosystem combines technical knowledge,
            professional development, practical exposure and innovation
            capability to build industry-ready talent at every level.
          </p>
        </div>

        {/* Programme Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6 mb-10 md:mb-12">
          {trainingProgrammes.map((prog) => {
            const body = (
              <>
                {prog.logo ? (
                  <div className="w-full h-12 flex items-center justify-start mb-4">
                    <img
                      src={prog.logo}
                      alt={prog.name}
                      className="max-h-full max-w-[140px] object-contain"
                    />
                  </div>
                ) : (
                  <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4">
                    <i className={`${prog.icon} text-xl`} />
                  </div>
                )}
                <div className="text-xs font-bold text-primary-500 mb-1">
                  {prog.code}
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                  {prog.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {prog.description}
                </p>
                {prog.link && (
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap">
                    Learn More
                    <i className="ri-arrow-right-line text-base" />
                  </span>
                )}
              </>
            );

            if (prog.link) {
              return (
                <a
                  key={prog.code}
                  href={prog.link}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-300/60 transition-colors flex flex-col"
                >
                  {body}
                </a>
              );
            }

            return (
              <div
                key={prog.code}
                className="bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-300/60 transition-colors flex flex-col"
              >
                {body}
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="https://training.textiletoday.com.bd/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Explore Training
            <i className="ri-external-link-line" />
          </a>
        </div>
      </div>
    </section>
  );
}